export default __webpack_public_path__ + "static/media/bg.2768f65e.jpg";